/** Bezeichnung einer Belegung am Rabatt: Fach und Lehrkraft, keine Kennung. */

const KENNUNG = /^[0-9a-f]{8}-[0-9a-f]{4}-/i;

function lesbar(value) {
  const text = String(value || '').trim();
  if (!text || /^\d+$/.test(text) || KENNUNG.test(text)) return '';
  return text;
}

export function enrollmentDiscountLabel(enrollment) {
  if (!enrollment) return '';
  const course = enrollment.course || {};
  const titleSource = lesbar(enrollment.course_name)
    || lesbar(course.name)
    || lesbar(enrollment.subject_name)
    || lesbar(course.subject_name);
  const minutes = enrollment.duration_minutes || course.duration_minutes;
  let title = titleSource;
  if (title && minutes && !/\d+\s*Min/i.test(title)) {
    title = `${title} ${minutes} Min.`;
  } else if (title) {
    title = title.replace(/(\d+\s*Min)\.?$/i, (_, minutesLabel) => `${minutesLabel}.`);
  }
  const teacher = lesbar(enrollment.teacher_name) || lesbar(course.teacher_name);
  const lehrkraft = teacher ? `Lehrkraft ${teacher}` : '';
  return [title, lehrkraft].filter(Boolean).join(' – ');
}
